// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo-module--logo--NR-RC","containerP":"Logo-module--container-p--1kZb5","logoBox":"Logo-module--logo-box--2YMxC","logoSvg":"Logo-module--logo-svg--aKkNQ"};